import { supabase } from "@/integrations/supabase/client";

export type ActivityAction = 
  | 'status_changed'
  | 'note_added'
  | 'call_scheduled'
  | 'call_rescheduled'
  | 'call_cancelled'
  | 'document_created'
  | 'document_edited'
  | 'document_previewed'
  | 'document_sent'
  | 'document_signed'
  | 'document_deleted'
  | 'document_expired'
  | 'document_cancelled'
  | 'email_sent'
  | 'email_cancelled'
  | 'email_scheduled'
  | 'scheduled_email_sent'
  | 'vendor_added'
  | 'vendor_updated'
  | 'itinerary_saved'
  | 'package_updated'
  | 'payment_received'
  | 'payment_link_generated'
  | 'contract_email_opened'
  | 'contract_viewed'
  | 'payment_method_selected';

interface LogActivityParams {
  inquiryId: string;
  action: ActivityAction;
  description: string;
  metadata?: Record<string, any>;
}

export async function logActivity({ inquiryId, action, description, metadata = {} }: LogActivityParams) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    const { error } = await supabase
      .from('inquiry_activity_logs')
      .insert({
        inquiry_id: inquiryId,
        user_id: user?.id || null,
        action_type: action,
        action_description: description,
        metadata,
      });

    if (error) {
      console.error('Failed to log activity:', error);
    }
  } catch (err) {
    console.error('Activity logging error:', err);
  }
}
